import styled from "@emotion/styled";
import { MDSButton } from "@/mds/components/buttons/button";
import { Theme } from "@emotion/react";

export const StyledToggleButton = styled(MDSButton)<{ $isToggled: boolean }>`
  height: auto;
  padding: ${({ theme }: { theme: Theme }) => theme.spacing["2"]}
    ${({ theme }: { theme: Theme }) => theme.spacing["3"]};
  color: ${({ theme, $isToggled }: { theme: Theme; $isToggled: boolean }) =>
    $isToggled ? theme.colors.text.emphasis : theme.colors.text.tertiary};

  border: none;

  background-color: ${({ theme, $isToggled }: { theme: Theme; $isToggled: boolean }) =>
    $isToggled
      ? theme.colors.background.button.toggle.toggled
      : theme.colors.background.button.toggle.default};

  &[data-hovered]:not([data-disabled]):not(:has(.mds-toggle-button-clear:hover)) {
    background-color: ${({ theme, $isToggled }: { theme: Theme; $isToggled: boolean }) =>
      $isToggled
        ? theme.colors.background.button.toggle.toggledHover
        : theme.colors.background.button.toggle.hover};
  }

  &:has(.mds-toggle-button-clear:hover) {
    background-color: ${({ theme, $isToggled }: { theme: Theme; $isToggled: boolean }) =>
      $isToggled
        ? theme.colors.background.button.toggle.toggled
        : theme.colors.background.button.toggle.default};
  }

  & .mds-icon-wrapper .mds-icon {
    color: ${({ theme, $isToggled }: { theme: Theme; $isToggled: boolean }) =>
      $isToggled ? theme.colors.icon.selected : theme.colors.icon.placeholder};
  }
`;

export const StyledSelectedButton = styled.div`
  border-radius: 100%;
  height: 16px;
  width: 16px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
  pointer-events: auto;

  &:hover {
    background-color: ${({ theme }: { theme: Theme }) =>
      theme.colors.background.button.toggle.toggledHover};
  }
`;
